(function ($) {
    'use strict';

    var map; //<-- This is now available to both event listeners and the initialize() function
    var mapCenter; // Declare a variable to store the center of the map
    var centerMarker; // declare your marker
    var centerMarker2; // declare your marker

    function initialize() {
        var mapOptions = {
            // How zoomed in you want the map to start at (always required)
            zoom: 13,
            panControl: false,
            rotateControl: false,
            scaleControl: false,
            mapTypeControl: true,
            streetViewControl: false,
            scrollwheel: false,
            zoomControl: true,

            // The latitude and longitude to center the map (always required)
            //center: new google.maps.LatLng(55.894844, 23.362054), // center

            // How you would like to style the map.
            // This is where you would paste any style found on Snazzy Maps.
            styles: [{"featureType":"all","elementType":"all","stylers":[{"hue":"#009aff"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#0e4880"},{"lightness":"0"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"11"}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":"-2"},{"gamma":"5.24"},{"weight":"1.48"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#264058"},{"lightness":"35"},{"saturation":"-48"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"simplified"},{"color":"#187fc3"},{"lightness":"58"},{"saturation":"-30"}]}]
        };

        mapCenter = new google.maps.LatLng(54.697859, 25.309292);

        if ($('#map').length > 0) {
            map = new google.maps.Map(document.getElementById("map"), mapOptions);
            map.setCenter(mapCenter);
            map.panBy(-450, -100)
        }

        var image = '../wp-content/themes/pr_impact/assets/images/pin.png';

        // Create a new marker and add it to the map
        centerMarker = new google.maps.Marker({
            position: new google.maps.LatLng(54.706777, 25.268003),
            map: map,
            icon: image,
            title: ''
        });
        centerMarker2 = new google.maps.Marker({
            position: new google.maps.LatLng(54.689532, 25.276056),
            map: map,
            icon: image,
            title: ''
        });
    }

    if ($('#map').length > 0) {
        google.maps.event.addDomListener(window, 'load', initialize);
    }
})(jQuery);